/** @format */

import styled from '@emotion/styled';

const StyledHeaderSubtext = styled.div`
  font-size: 12pt;
`;

export default StyledHeaderSubtext;
